module.exports = __webpack_public_path__ + "static/media/infinityHpSign-gray.c2e88bce.svg";